<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M7 4V6.5C7 6.91421 7.33579 7.25 7.75 7.25H12.25C12.6642 7.25 13 6.91421 13 6.5V4M7 15.25V12.5C7 12.0858 7.33579 11.75 7.75 11.75H12.25C12.6642 11.75 13 12.0858 13 12.5V15.25M7.75 16H12.25M16 6.87132V14.5C16 15.3284 15.3284 16 14.5 16H5.5C4.67157 16 4 15.3284 4 14.5V5.5C4 4.67157 4.67157 4 5.5 4H13.1287C13.5265 4 13.908 4.15803 14.1894 4.43934L15.5606 5.81066C15.842 6.09197 16 6.47349 16 6.87132Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'SaveFiltersIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>